// Dependencies
import styled, { css } from "styled-components";

// Utils
import { MediaQueries } from "assets/styles/settings";
import { theme } from "config/theme";

type ContainerStyleProps = {
    isFilled: boolean;
};

export const Container = styled.div<ContainerStyleProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 9px 12px;
    border-radius: 4px;
    border: 1px solid ${theme.colors.base[300]};

    ${MediaQueries.BIGGER_THAN_TABLET} {
        width: 320px;
    }

    ${MediaQueries.BIGGER_THAN_LARGE} {
        width: 140px;
    }

    ${({ isFilled }) =>
        !!isFilled &&
        css`
            background-color: ${theme.colors.base[200]};
        `}
`;

export const Label = styled.div`
    font-family: "Nunito Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${theme.colors.base[400]};
`;
